var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 462,
    viewBox: "0 0 325 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -117.695,
    y: 135.231,
    width: 421,
    height: 191,
    rx: 85.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -132.951,
    y: 181.084,
    width: 421,
    height: 191,
    rx: 85.5,
    transform: "rotate(-12 -132.951 181.084)",
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -138.34,
    y: 229.106,
    width: 421,
    height: 191,
    rx: 85.5,
    transform: "rotate(-24 -138.34 229.106)",
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -133.627,
    y: 277.199,
    width: 421,
    height: 191,
    rx: 85.5,
    transform: "rotate(-36 -133.627 277.199)",
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -119.017,
    y: 323.261,
    width: 421,
    height: 191,
    rx: 85.5,
    transform: "rotate(-48 -119.017 323.261)",
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -95.1505,
    y: 365.28,
    width: 421,
    height: 191,
    rx: 85.5,
    transform: "rotate(-60 -95.1505 365.28)",
    stroke: "white",
    strokeOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/oval.9de6128936513c1d4e83b630c484a9ab.svg";
export { ForwardRef as ReactComponent };